"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameOver = exports.GAME_OVER = void 0;
exports.GAME_OVER = 'GAME_OVER';
function gameOver(players) {
    return { type: exports.GAME_OVER, players: players };
}
exports.gameOver = gameOver;
